import script from "./Animations.vue?vue&type=script&lang=js"
export * from "./Animations.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__